module.exports = __webpack_public_path__ + "img/27.3b6d89f8.jpg";